
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 341.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 0h512v341.3H0z"}}),_c('path',{attrs:{"fill":"#0052B4","d":"M0 341.3h512V0z"}}),_c('path',{attrs:{"fill":"#FFDA44","d":"M250.4 0H0v166.9z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M140.4 118.3l12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"}}),_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"9","stroke-miterlimit":"10","cx":"140.4","cy":"160.6","r":"57.7"}})])
          )
        }
      }
    